/**  竞赛  */
import axios from '@/utils/axios'
const VUE_APP_ZLJT_BASE_API = window.ZLJT_BASE_API || process.env.VUE_APP_ZLJT_BASE_API
// const VUE_APP_ZLJT_BASE_API = 'https://zljtproapi.cailian.net'
const VUE_APP_BigDataOS_API = window.BigDataOS_API || process.env.VUE_APP_BigDataOS_API

const VUE_APP_UPLOAD_URL = window.UPLOAD_URL || process.env.VUE_APP_UPLOAD_URL
// import qs from 'qs'
export default {
    jumPage: (params) => 
        axios.post('/api-oauth/oauth/sign', params),
    
    raceHomeList: () => 
        axios.post('/api-match-practise/practise/js/index',{}), // 首页列表
    
    raceHomeTestQuestions: (params) => 
        axios.post('/api-match-practise/practise/js/home',params), // 竞赛答题主页面, 初始加载试卷及各试题状态

    raceAnswerRecord: (params) => 
        axios.post('/api-match-practise/practise/js/answer/record',params), // 竞赛答题主页面, 答题 记录每道题所答答案

    answerNextStation: (params) => 
        axios.post('/api-match-practise/practise/js/answer/nextStation',params), // 提交下一岗

    answerRevertStation: (params) => 
        axios.post('/api-match-practise/practise/js/answer/revert',params), // 返回上一岗

    raceAnswerCommi: (params) => 
        axios.post('/api-match-practise/practise/js/answer/commit',params), // 提交结果
    
    racePlayerDetail: (params) => 
        axios.post('/api-match-practise/practise/js/playerDetail',params), // 选手详情

    raceAnswerShow: (params) => 
        axios.post('/api-match-practise/practise/js/answer/show',params), // 回显作答情况

    racePlayerNotice: (params) => 
        axios.post('/api-match-practise/practise/js/playerNotice',params), //大赛须知

    taskSignConfirm: (params) => 
        axios.post('/api-match-practise/practise/js/task/sign/confirm',params), //标记试题

    taskSignCancel: (params) => 
        axios.post('/api-match-practise/practise/js/task/sign/cancel',params), //取消标记试题
    
    raceTeamProgress: (params) => 
        axios.post('/api-match-practise/practise/js/teamProgress',params), // 获得团队作答进度

    raceDirectRefresh: (params) => 
        axios.post('/api-match-practise/practise/js/direct/refresh',params), // 定时任务 每五秒刷新
        
    raceTaskStatus: (params) => 
        axios.post('/api-match-practise/practise/js/task/status',params), // 定时任务 获取任务状态变化

    racePaperSubmit: (params) => 
        axios.post('/api-match-practise/practise/js/paper/submit',params), // 交卷
    
    raceSharedFile: (params) => 
        axios.post('/api-match-practise/practise/js/sharedFile',params), // 文件共享 列表

    raceAttachmentList: (params) =>
        axios.post('/api-match-practise/practise/js/attachmentList',params), // 试题上传附件列表

    deleteAttachment: (id) =>
        axios.get(`/api-match-practise/practise/js/delete/attachment/${id}`), // 删除附件列表
    
    racePaperCheckCount: (params) => //
        axios.post(`/api-match-practise/practise/js/paper/check/count`,params), // 试题完成数量 交卷时使用

    raceGetToken: (params, url) => //
        axios.post(`${url ? url : VUE_APP_ZLJT_BASE_API}/api-oauth/v1/oauth/v2/oauth/token`,params), // 跳转前获取 token 商旅
    
    getVncUrl: (params)=>
        axios.get(`${VUE_APP_ZLJT_BASE_API}/api-cecstack/cecloud/api/instances/vnc-url?${params}`), //  获取远程连接地址

    bigDataOSGetToken: (params) => //
        axios.post(`${VUE_APP_BigDataOS_API}/connect/token`,params), // 跳转前获取 token 大数据

    fileRaceUploadExcel: `${VUE_APP_UPLOAD_URL}/file/race/uploadExcel`, // 文件共享 上传  

    fileRaceUploadTeamSharedFile: `${VUE_APP_UPLOAD_URL}/file/race/uploadTeamSharedFile`, // 文件共享 上传   
        
    getIframeUrl: (url,params) =>
        axios.post(url,params), // 获取Iframe 参数

    getFile: (url) =>
        axios({
            method: 'get',
            url: `/api-match-practise/practise/js/paper/attach/download?url=${url}`,
            responseType: 'arraybuffer'
        }), // 导出选手

    /**
     * 
     *  查看答案功能 - 迁移
     * 
     */
    
    // 获取单多判答案
    racePaperAnswer: (params) =>
        axios.post(`/api-match-practise/practise/js/paper/answer`, params),

    // 查询评分详情   --- 大赛
    getRaceScoreLog: (params) =>
        axios.post('/api-score/noAuth/race-score-log',params),
     // 成绩查询
    // 根据试卷code 查询试卷详情
    getInfoOfPaperCode: (params, opts) =>
        axios.get(`/api-resource/resources/soreView/getPaper/${params}`, opts),// 查询分数详情

    getScoreDetail: (params) =>
        axios.post('/api-match-practise/practise/sw/watching/title', params),

    // 理论题
    getTheory: (params) =>
        axios.post('/api-match-practise/practise/sw/watching/subject/detail', params),


    // 学生埋点   --- 大赛
    getRaceScoreCompare: (params) =>
        axios.get('/api-score/noAuth/race-compare-result', {params}),


    getQuestionJSON: (questionId)=>
        axios.get(`/api-resource/q_e_json/getJson?questionId=${questionId}`), // 获取简答列表 JSON

    saveJDData: (params)=>
        axios({
            url: `${VUE_APP_ZLJT_BASE_API}/api-formclick/zljt/formclick/save`,
            data: params,
            method: 'post',
            headers:{
                authorization: `bearer ${sessionStorage.getItem('zljtToken')}`,
                isIT: params.isIT
            }
        }), // 试题 简答列表 保存

    showJDData: (params)=>
        axios({
            url: `${VUE_APP_ZLJT_BASE_API}/api-formclick/zljt/formclick/list`,
            data: params,
            method: 'post',
            headers:{
                authorization: `bearer ${sessionStorage.getItem('zljtToken')}`
            }
        }), // 试题 简答列表 回显

    raceIsIT: (params) => 
        axios.post('/api-match-practise/practise/sw/paper/question/isIT', params), // 判断试题是否为IT类试题
    
}